import React from 'react'
import PropTypes from 'prop-types'
import { Article } from '../components/Article'
import board6 from '../images/board6.jpg'

export function A06({ index }) {
  return (
    <Article
      index={index}
      heading="People buy these tokens and the entrepreneur builds out the app or service."
      image={board6}
      imageDescription="A user manages their token balance on a crypto-exchange app."
    >
      <div className="article-row">
        <div>
          <h3>The Token Holders</h3>
          <p>
            Individuals from around the world acquire CanCan's governance
            tokens, funding Alice's continued development of the app.
          </p>
          <h4>Why would people buy tokens of an MVP app like CanCan?</h4>
          <p>
            Giving users a stake in the governance of a service or app can
            foster deeper user connections and engagement with the product while
            creating a community that is invested in its success and
            improvement. Governance tokens can allow people to vote on questions
            such as:
          </p>
          <ol>
            <li>
              “A code upgrade for a new feature to CanCan is proposed. Should it
              be deployed?”
            </li>
            <li>
              “A user is misbehaving on the platform. Should the user be
              banned?”
            </li>
            <li>
              “A proposal for CanCan to automatically delete videos after 30
              days is made. Do you agree?”
            </li>
          </ol>
          <h4>Where are tokens bought?</h4>
          <p>People can buy tokens at different digital exchanges.</p>
        </div>
      </div>
    </Article>
  )
}

A06.propTypes = {
  index: PropTypes.number.isRequired,
}
